import React from 'react'
import { Tag } from 'antd'
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, ExclamationCircleOutlined, MinusCircleOutlined } from '@ant-design/icons'
import { StatusTone, statusLabel, toneOf } from '../../domain/Status'

const toneIcons: Record<StatusTone, React.ReactNode> = {
    success: <CheckCircleOutlined />,
    processing: <ClockCircleOutlined />,
    warning: <ExclamationCircleOutlined />,
    error: <CloseCircleOutlined />,
    default: <MinusCircleOutlined />,
}

export const ToneIcon: React.FC<{ status: string }> = ({ status }) => {
    const tone = toneOf(status)
    return (
        <span className={`tone-${tone}`} aria-hidden>
            {toneIcons[tone]}
        </span>
    )
}

const StatusTag: React.FC<{ status: string; label?: string }> = ({ status, label }) => {
    const tone = toneOf(status)
    return (
        <Tag color={tone} icon={toneIcons[tone]}>
            {label ?? statusLabel(status)}
        </Tag>
    )
}

export default StatusTag
